<mat-form-field [formGroup]="formGroup" class="filter-field" color="primary" appearance="outline">
  <mat-select [formControlName]="selectColumn.filterName"
              [multiple]="selectColumn.multiple">
    <mat-option [class]="alignClass" *ngIf="!selectColumn.multiple" [value]="null"> -
    </mat-option>
    <mat-option [class]="alignClass" *ngFor="let item of items"
                [value]="item.value">{{item.text | translate}}</mat-option>
  </mat-select>
</mat-form-field>
